export function getdata() {
	let obj = {
		formdatajbxx: {
			cains: "",
			qij: "",
			mingxlx: "0",
		},
		formlistjbxx: [{
				prop: "cains",
				label: "财务年度	",
				type: "select",
				selectval: [],
				isnotnull: true,
			},
			{
				prop: "qij",
				label: "财务期间",
				type: "select",
				selectval: [],
				isnotnull: true,

			},
			{
				prop: "mingxlx",
				label: "凭证类型",
				type: "select",
				selectval: [{
					label: "全部",
					value: "-1"
				}, {
					label: "正常凭证",
					value: "0"
				}, {
					label: "调整凭证",
					value: "1"
				}],
				isnotnull: false,
			
			},

		],
		formdatapzxx: {
			pingzlx: "0",
			pingzbhStart: "",
			pingzbh: "",
			pingzbhEnd: "",
			zhidr: "",
		},
		formlistpzxx: [{
				prop: "pingzlx",
				label: "凭证号类型",
				type: "select",
				selectval: [{
					label: "ERP凭证",
					value: "0"
				}, {
					label: "系统凭证",
					value: "1"
				}],
			},
			{
				prop: "pingzbhStart",
				label: "凭证编号从",
				type: "input",

			},

			{
				prop: "zhidr",
				label: "制单人",
				type: "input",

			}, {
				prop: "pingzbh",
				label: "凭证编号",
				type: "input",

			},
			{
				prop: "pingzbhEnd",
				label: "凭证编号到",
				type: "input",

			},

		],
	}
	return obj
}
